import React, { Component } from 'react';
import { Container } from 'react-grid-system';
import { connect } from 'react-redux';
import { RouteProps } from 'react-router-dom';
import store from '../../store';
import CatalogProducts from './catalog-products';
import './catalog.scss';

interface SearchProps {
  products: any,
  match: any,
  history: any
}

interface SearchState {
}

const mapStateToProps = (state: any) => {
  return {
    products: state.products?.filter((p: any) => p.active && p.brandActive && p.categoryActive && p.warehouseCount > 0)
  }
}

class CatalogPage extends Component<SearchProps & RouteProps, SearchState> {

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0)
      store.dispatch({ type: 'REFRESH_PRODUCTS' })
    });
  }

  render() {
    return (
      <div className="page catalog-page">
        <Container fluid={true} className="search-page-container" id="page-container">
          <CatalogProducts products={this.props.products}></CatalogProducts>
        </Container>
      </div>
    );
  }
}

export default connect(mapStateToProps)(CatalogPage);